module.exports = __webpack_public_path__ + "static/media/heart-red.5d169f06.svg";